import { render, staticRenderFns } from "./ValoracionesSeccion.vue?vue&type=template&id=38796fa0&scoped=true"
import script from "./ValoracionesSeccion.vue?vue&type=script&lang=js"
export * from "./ValoracionesSeccion.vue?vue&type=script&lang=js"
import style0 from "./ValoracionesSeccion.vue?vue&type=style&index=0&id=38796fa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38796fa0",
  null
  
)

export default component.exports